import Image from 'next/image';
import styles from './blog-module-card.module.scss';

interface BlogModuleCardProps {
    tag: string;
    description: string;
    image: string;
    color?: string;
    url: string;
}

export function BlogModuleCard({tag, description, image, color, url}: BlogModuleCardProps) {
    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles['blogModuleCard']}
        >
            <div className={styles['imageContainer']}>
                <Image
                    src={image}
                    alt="Course preview"
                    className={styles['image']}
                    width={115}
                    height={115}
                />
            </div>
            <div className={styles['content']}>
                <span
                    className={`${styles['tag']} ${color ? styles[color] : ''}`}
                    data-testid="blog-module-card-tag"
                >
                    {tag}
                </span>
                <p className={styles['description']}>{description}</p>
            </div>
        </a>
    );
}
